function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//@ts-nocheck

// Customizable Area Start

import moment from "moment";
import { Grid, Box, CircularProgress } from "@material-ui/core";
import React from "react";
import storage from "../../../framework/src/StorageProvider";
export const getUserType = () => {
  var _userInformation, _userInformation2;
  let userInformation = localStorage.getItem('userInfo');
  userInformation = JSON.parse(userInformation);
  const usetType = ((_userInformation = userInformation) === null || _userInformation === void 0 || (_userInformation = _userInformation.data) === null || _userInformation === void 0 || (_userInformation = _userInformation.attributes) === null || _userInformation === void 0 ? void 0 : _userInformation.role) === 'CustomerAdmin' || ((_userInformation2 = userInformation) === null || _userInformation2 === void 0 || (_userInformation2 = _userInformation2.data) === null || _userInformation2 === void 0 || (_userInformation2 = _userInformation2.attributes) === null || _userInformation2 === void 0 ? void 0 : _userInformation2.role) === 'Customer Admin' ? 'CustomerAdmin' : 'employee';
  return usetType;
};
export const getformatedCurrentDate = type => {
  const newDate = new Date();
  const todayDate = moment(newDate).format("YYYY-MM-DD");
  const todayTime = moment(newDate).format("HH:MM");
  // return (`${todayDate}T${todayTime}`);
  return type === "time" ? "".concat(todayDate, "T").concat(todayTime) : todayDate;
};

// export const getformatedMonthBackDate = () => {
//     const today = new Date();
//     today.setMonth(today.getMonth() - 1)
//     const todayDate = moment(today).format("YYYY-MM-DD");
//     const todayTime = moment(today).format("HH:MM");
//     // return (`${todayDate}T${todayTime}`);
//     return (todayDate);
// }

export const getformatedYesterDayDate = type => {
  const newDate = new Date(new Date().getTime() - 24 * 60 * 60 * 1000);
  ;
  const todayDate = moment(newDate).format("YYYY-MM-DD");
  const todayTime = moment(newDate).format("HH:MM");
  // return (`${todayDate}T${todayTime}`);    
  return type === "time" ? "".concat(todayDate, "T").concat(todayTime) : todayDate;
};
export const pageLoader = () => {
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    style: {
      display: "flex",
      width: '100%',
      minHeight: "200px"
    }
  }, /*#__PURE__*/React.createElement(Box, {
    style: {
      margin: 'auto'
    }
  }, /*#__PURE__*/React.createElement(CircularProgress, null)));
};
export const noDataFound = () => {
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    style: {
      display: "flex",
      width: '100%',
      minHeight: "200px"
    }
  }, /*#__PURE__*/React.createElement(Box, {
    style: {
      margin: 'auto'
    }
  }, /*#__PURE__*/React.createElement("h2", null, "No Data Found")));
};
export const getUserInfo = filterType => {
  var _userInformation3, _userInformation4;
  let userInformation = localStorage.getItem('userInfo');
  userInformation = JSON.parse(userInformation);
  const usetType = ((_userInformation3 = userInformation) === null || _userInformation3 === void 0 || (_userInformation3 = _userInformation3.data) === null || _userInformation3 === void 0 || (_userInformation3 = _userInformation3.attributes) === null || _userInformation3 === void 0 ? void 0 : _userInformation3.role) === 'CustomerAdmin' || ((_userInformation4 = userInformation) === null || _userInformation4 === void 0 || (_userInformation4 = _userInformation4.data) === null || _userInformation4 === void 0 || (_userInformation4 = _userInformation4.attributes) === null || _userInformation4 === void 0 ? void 0 : _userInformation4.role) === 'Customer Admin' ? 'CustomerAdmin' : 'employee';
  if (filterType === 'subDevicesList') {
    let subDevicesList = [];
    if (usetType == 'CustomerAdmin') {
      var _userInformation5;
      (_userInformation5 = userInformation) === null || _userInformation5 === void 0 || (_userInformation5 = _userInformation5.data) === null || _userInformation5 === void 0 || (_userInformation5 = _userInformation5.attributes) === null || _userInformation5 === void 0 || (_userInformation5 = _userInformation5.devices) === null || _userInformation5 === void 0 || _userInformation5.data.map(item => {
        item.attributes.sub_devices.map(subDevice => subDevicesList.push(subDevice));
      });
    } else {
      var _userInformation6;
      (_userInformation6 = userInformation) === null || _userInformation6 === void 0 || (_userInformation6 = _userInformation6.data) === null || _userInformation6 === void 0 || (_userInformation6 = _userInformation6.attributes) === null || _userInformation6 === void 0 || (_userInformation6 = _userInformation6.devices) === null || _userInformation6 === void 0 || _userInformation6.data.map(item => subDevicesList.push(item.attributes));
    }
    return subDevicesList;
  } else if (filterType === "userName") {
    var _userInformation7, _userInformation8;
    return "".concat((_userInformation7 = userInformation) === null || _userInformation7 === void 0 || (_userInformation7 = _userInformation7.data) === null || _userInformation7 === void 0 ? void 0 : _userInformation7.attributes.first_name, " ").concat((_userInformation8 = userInformation) === null || _userInformation8 === void 0 || (_userInformation8 = _userInformation8.data) === null || _userInformation8 === void 0 ? void 0 : _userInformation8.attributes.last_name);
  } else {
    return userInformation;
  }
};
export const getDeviceDetailFromLocationObjBySid = async (imei, sid) => {
  let deviceList = localStorage.getItem('locationWiseDevices') || [];
  deviceList = JSON.parse(deviceList);
  let device = {};
  deviceList.map(location => {
    Object.values(location).map(dev => dev.map(subDev => {
      var _subDev$sub_device;
      if (subDev.imei == imei && ((_subDev$sub_device = subDev.sub_device) === null || _subDev$sub_device === void 0 ? void 0 : _subDev$sub_device.sid) == sid) {
        device = _objectSpread(_objectSpread({}, subDev.sub_device), {}, {
          imei: imei
        });
      }
    }));
  });
  return device;
};

// export const getTimeDiffInsec = (d1: any, d2: any) => {
//     var date1 = new Date(d1);
//     var date2 = new Date(d2);
//     var diff = date2.getTime() - date1.getTime();
//     var msec = diff;
//     var hh = Math.floor(msec / 1000 / 60 / 60);
//     msec -= hh * 1000 * 60 * 60;
//     var mm = Math.floor(msec / 1000 / 60);
//     msec -= mm * 1000 * 60;
//     var ss = Math.floor(msec / 1000);
//     msec -= ss * 1000;
//     return ({ hrs: hh, min: mm, sec: ss });
// }

// this is demo one not exact one
// export const getTimeDiffByMqtt = async (imei: any, sid: any, type: string) => {
//     const deviceObj = await getMqttDataByImeiSid(imei, sid);
//     var date1 = new Date();
//     if (type === "start") {
//         date1 = new Date("Thu Jan 06 2022 17:12:06 GMT+0530 (India Standard Time)");
//     } else if (type === "idle") {
//         date1 = new Date("Thu Jan 06 2022 17:12:06 GMT+0530 (India Standard Time)");
//     } else if (type === "down") {
//         date1 = new Date("Thu Jan 06 2022 17:12:06 GMT+0530 (India Standard Time)");
//     }
//     var date2 = new Date();
//     var diff = date2.getTime() - date1.getTime();
//     var msec = diff;
//     var hh = Math.floor(msec / 1000 / 60 / 60);
//     msec -= hh * 1000 * 60 * 60;
//     var mm = Math.floor(msec / 1000 / 60);
//     msec -= mm * 1000 * 60;
//     var ss = Math.floor(msec / 1000);
//     msec -= ss * 1000;
//     return ({ hrs: hh, min: mm, sec: ss })
// };

export const getTimeObjByTimeString = async time => {
  const timeOBj = time.split(":");
  return {
    hrs: timeOBj[0] ? parseInt(timeOBj[0]) : 0,
    min: timeOBj[1] ? parseInt(timeOBj[1]) : 0
  };
};
export const getUserTypeMob = async () => {
  var _userInformation$data, _userInformation$data2;
  let userInformation = await getUserInfoMob();
  console.log("information:0", userInformation);
  const userType = (userInformation === null || userInformation === void 0 || (_userInformation$data = userInformation.data) === null || _userInformation$data === void 0 || (_userInformation$data = _userInformation$data.attributes) === null || _userInformation$data === void 0 ? void 0 : _userInformation$data.role) === 'CustomerAdmin' || (userInformation === null || userInformation === void 0 || (_userInformation$data2 = userInformation.data) === null || _userInformation$data2 === void 0 || (_userInformation$data2 = _userInformation$data2.attributes) === null || _userInformation$data2 === void 0 ? void 0 : _userInformation$data2.role) === 'Customer Admin' ? 'CustomerAdmin' : 'employee';
  console.log("type uset", userType);
  return userType;
};
export const getTimeObj = time => {
  const timeOBj = time ? time.split(":") : ['00', '00', '00'];
  let hours = timeOBj[0] < 10 ? "0".concat(parseInt(timeOBj[0])) : parseInt(timeOBj[0]);
  let mins = timeOBj[1] < 10 ? "0".concat(parseInt(timeOBj[1])) : parseInt(timeOBj[1]);
  return {
    hrs: timeOBj[0] ? hours : 0,
    min: timeOBj[1] ? mins : 0
  };
};
export const getInitialValue = value => {
  return !value ? 0.00 : value;
};
const getUserInfoMob = async () => {
  var _userInfo;
  let userInfo = await (storage === null || storage === void 0 ? void 0 : storage.get('userInfo'));
  userInfo = userInfo ? JSON.parse(userInfo) : null;
  console.log("promise123", userInfo);
  return {
    data: (_userInfo = userInfo) === null || _userInfo === void 0 ? void 0 : _userInfo.data
  };
};
export const getUserInfoForMob = async type => {
  var _userInformation$data3, _userInformation$data4;
  let userInformation = await getUserInfoMob();
  const userType = (userInformation === null || userInformation === void 0 || (_userInformation$data3 = userInformation.data) === null || _userInformation$data3 === void 0 || (_userInformation$data3 = _userInformation$data3.attributes) === null || _userInformation$data3 === void 0 ? void 0 : _userInformation$data3.role) === 'CustomerAdmin' || (userInformation === null || userInformation === void 0 || (_userInformation$data4 = userInformation.data) === null || _userInformation$data4 === void 0 || (_userInformation$data4 = _userInformation$data4.attributes) === null || _userInformation$data4 === void 0 ? void 0 : _userInformation$data4.role) === 'Customer Admin' ? 'CustomerAdmin' : 'employee';
  console.log("type of user", userType);
  console.log("userInfo", userInformation);
  if (type === 'devices') {
    var _userInformation$data5;
    return userInformation === null || userInformation === void 0 || (_userInformation$data5 = userInformation.data) === null || _userInformation$data5 === void 0 || (_userInformation$data5 = _userInformation$data5.attributes) === null || _userInformation$data5 === void 0 || (_userInformation$data5 = _userInformation$data5.devices) === null || _userInformation$data5 === void 0 ? void 0 : _userInformation$data5.data;
  } else if (type === 'subDevicesList') {
    let subDevicesList = [];
    if (userType == 'CustomerAdmin') {
      var _userInformation$data6;
      userInformation === null || userInformation === void 0 || (_userInformation$data6 = userInformation.data) === null || _userInformation$data6 === void 0 || (_userInformation$data6 = _userInformation$data6.attributes) === null || _userInformation$data6 === void 0 || (_userInformation$data6 = _userInformation$data6.devices) === null || _userInformation$data6 === void 0 || _userInformation$data6.data.map(item => {
        item.attributes.sub_devices.map(subDevice => subDevicesList.push(subDevice));
      });
    } else {
      var _userInformation$data7;
      userInformation === null || userInformation === void 0 || (_userInformation$data7 = userInformation.data) === null || _userInformation$data7 === void 0 || (_userInformation$data7 = _userInformation$data7.attributes) === null || _userInformation$data7 === void 0 || (_userInformation$data7 = _userInformation$data7.devices) === null || _userInformation$data7 === void 0 || _userInformation$data7.data.map(item => subDevicesList.push(item.attributes));
    }
    return subDevicesList;
  } else if (type === "userName") {
    var _userInformation$data8, _userInformation$data9;
    return "".concat(userInformation === null || userInformation === void 0 || (_userInformation$data8 = userInformation.data) === null || _userInformation$data8 === void 0 ? void 0 : _userInformation$data8.attributes.first_name, " ").concat(userInformation === null || userInformation === void 0 || (_userInformation$data9 = userInformation.data) === null || _userInformation$data9 === void 0 ? void 0 : _userInformation$data9.attributes.last_name);
  } else if (type === "userData") {
    if (userType == 'CustomerAdmin') {
      var _userInformation$data0;
      return userInformation === null || userInformation === void 0 || (_userInformation$data0 = userInformation.data) === null || _userInformation$data0 === void 0 ? void 0 : _userInformation$data0.attributes;
    }
    // return userInformation;
  } else {
    return userInformation;
  }
};
export const getDeviceDetailsBySidMob = async (imei, sid) => {
  let deviceList = await getUserInfoForMob('devices');
  const userType = await getUserTypeMob();
  let subDeviceObj = {};
  if (userType == 'CustomerAdmin') {
    for (let item of deviceList) {
      if (item.attributes.device_imei_number == imei) {
        const deviceInfo = item.attributes.sub_devices.filter(subDevice => subDevice.sid == sid);
        if ((deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.length) > 0) {
          subDeviceObj = deviceInfo[0];
          break;
        }
      }
    }
  } else {
    deviceList === null || deviceList === void 0 || deviceList.map(item => {
      if (item.attributes.imei_number == imei && item.attributes.sid == sid) {
        subDeviceObj = item.attributes;
      }
    });
  }
  console.log("getDeviceDetailsBySidMob: ", subDeviceObj);
  return subDeviceObj;
};

// export const getMqttSubDeviceDataBySid = (sid: any) => {
//     let devicesMqtt: any = localStorage.getItem('devicesMqtt');
//     let subDeviceDataByID: any = { sid: sid };
//     devicesMqtt = localStorage.getItem('devicesMqtt') ? JSON.parse(devicesMqtt) : [];
//     devicesMqtt.length > 0 && devicesMqtt.map((device: any) => {
//         device.subDevices.map((subDevice: any) => {
//             if (subDevice == sid) {
//                 subDeviceDataByID = subDevice;
//             }
//         })
//     })
//     return subDeviceDataByID;
// };

export const getFormatedDate = dateString => {
  const gevenDate = new Date(dateString);
  return {
    date: dateString ? gevenDate.toLocaleDateString() : "--/--/--",
    time: dateString ? gevenDate.toLocaleTimeString() : "--:--"
  };
};

// export const getTimeBystring = (dateString: any) => {
//     return !dateString || dateString !== 0 ? "--:--" : moment(dateString).format('hh:mm A');
// };

// export const getTimeFromString = () => {

// };

export const skipped = (ctx, value) => ctx.p0.skip || ctx.p1.skip ? value : undefined;
export const down = (ctx, value) => ctx.p0.parsed.y > ctx.p1.parsed.y ? value : undefined;

// Customizable Area End